module.exports = __webpack_public_path__ + "img/pointer.b44132ac.png";